import React from 'react';
import { screenSmMin, screenXsMax } from '@spotify-internal/encore-foundation';
import styled, { css } from 'styled-components';
import { useEncoreContextType } from "../../hooks/useEncoreContextType";
import { finaleBold, fontWeightBold, fontWeightBook, ie11Edge, typeStyleBody2, typeStyleBody3 } from "../../styles";
import { TextLink } from "../TextLink";
export var Link = styled( /*#__PURE__*/React.forwardRef(function Link(props, ref) {
  return /*#__PURE__*/React.createElement(TextLink, Object.assign({
    semanticColor: "textBase",
    standalone: true,
    ref: ref
  }, props));
})).withConfig({
  displayName: "Link",
  componentId: "fe80qw-0"
})(["display:block;", ";@media (max-width:", "){", ";}@media (min-width:", "){", ";}", ";"], function () {
  return useEncoreContextType(undefined, finaleBold());
}, screenXsMax, function () {
  return useEncoreContextType(css(["", ";font-weight:", ";"], typeStyleBody2(), fontWeightBold), undefined);
}, screenSmMin, function () {
  return useEncoreContextType(css(["", ";font-weight:", ";"], typeStyleBody3(), fontWeightBold), undefined);
}, ie11Edge(css(["font-weight:", ";"], fontWeightBook)));
export default Link;